/**
 * Compact day-interval formatter for FSRS rate-button hints.
 *
 *   < 1 day  → `Nh` (1h, 12h)            - anything less than a day
 *   < 60 days → `Nd` (1d, 4d, 30d)        - under two months
 *   < 365 days → `Nmo` (2mo, 11mo)        - under a year
 *   ≥ 365 days → `Ny` (1y, 3y)            - annual scale
 *
 * Round to the nearest unit so the buttons read as snackable numbers,
 * not decimal floats. Falls back to `<1m` for non-finite or negative
 * input so the existing static-default UI keeps rendering on bad data.
 */
export function formatInterval(days: number): string {
  if (!Number.isFinite(days) || days <= 0) return '<1m';
  if (days < 1) {
    const hours = Math.max(1, Math.round(days * 24));
    return `${hours}h`;
  }
  if (days < 60) {
    return `${Math.round(days)}d`;
  }
  if (days < 365) {
    return `${Math.round(days / 30)}mo`;
  }
  return `${Math.round(days / 365)}y`;
}
